<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <card-header title="Experiencias" route="Crear-Experiencia" buttonText="Nueva Experiencia" />
            <div class="row">
              <div class="col-md-3 col-12 py-2">
                <el-input
                  clearable
                  type="text"
                  placeholder="Nombre"
                  v-model="searchName"
                />
              </div>
         <!--     <div class="col-md-3 col-12">
                <el-select v-model="searchTrail" class="m-2" placeholder="Ruta" size="large" clearable>
                  <el-option
                    v-for="item in trails"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>-->
              <div class="col-md-3">
                <button
                  @click="handleSearch"
                  class="
                      float-start
                      btn btn-primary
                      text-white
                      bg-blue-600
                      rounded-lg
                      border border-primary
                      hover:bg-blue-900
                      mt-2
                    ">
                  Buscar
                </button>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase font-weight-bolder">
                      Nombre
                    </th>
                    <th class="d-none d-lg-table-cell text-uppercase font-weight-bolder text-left">
                      Ruta
                    </th>
                    <th class="d-none d-lg-table-cell text-uppercase font-weight-bolder text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in experiences" :key="item.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">
                            <router-link :to="{
                                name: 'Detalle-Experiencia',
                                params: { id: item.id },
                              }"
                            >
                              {{ item.name }}
                            </router-link>
                          </h6>
                          <div class="d-block d-lg-none">
                            <router-link
                                class="btn btn-link text-dark px-3 mb-0"
                                :to="{
                                       name: 'Actualizar-Experiencia',
                                       params: { id: item['id'] },
                                }">
                                <i
                                    class="fas fa-eye text-dark me-2"
                                    aria-hidden="true"
                                ></i
                                >Ver
                            </router-link>
                            <a
                                class="btn btn-link text-danger text-gradient px-3 mb-0"
                                href="javascript:;"
                                @click="handleDelete(item['id'])"
                            >
                              <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                              >Borrar
                            </a>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="d-none d-lg-table-cell text-left">
                      {{ item.trail.name }}
                    </td>
                    <td class="d-none d-lg-table-cell text-center">
                      <router-link
                        :to="{
                          name: 'Detalle-Experiencia',
                          params: { id: item.id },
                        }"
                      >
                        <a
                          class="btn btn-link text-dark px-3 mb-0"
                          href="javascript:;"
                        >
                          <i
                            class="fas fa-eye text-dark me-2"
                            aria-hidden="true"
                          ></i
                          >Ver
                        </a>
                      </router-link>
                      <router-link
                          :to="{
                          name: 'Actualizar-Experiencia',
                          params: { id: item.id },
                        }"
                      >
                        <a class="btn btn-link text-dark px-3 mb-0" href="javascript:;">
                          <i class="fa fa-pencil text-dark me-2" aria-hidden="true"></i>
                          Editar
                        </a>
                      </router-link>
                      <a
                        class="btn btn-link text-danger text-gradient px-3 mb-0"
                        href="javascript:;"
                        @click="handleDelete(item.id)"
                      >
                        <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                        >Borrar
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {ElMessageBox} from "element-plus";
import CardHeader from "@/components/CardHeader.vue";

const store = useStore();
const searchName = ref();
//const searchTrail = ref();

    onMounted( () => {
     // getTrails();
      getExperiences();
    });

//const trails = computed(() => store.state.trail.trails);
const experiences = computed(() => store.state.experience.experiences);

/*const getTrails = async () => {
  return await store.dispatch("trail/getTrails");
};*/
const getExperiences = async () => {
  return await store.dispatch("experience/getExperiences");
};

    const deleteExperience = async (experience) => {
      try {
        await store.dispatch("experience/deleteExperience", experience);
        await getExperiences();
      } catch (error) {
        console.log(error);
      }
    };

const handleSearch = () => {
  let payload = {};
  if (searchName.value) {
    payload.name = searchName.value;
  }
  store.dispatch("experience/getExperiences", payload);
};

    const handleDelete = (item) => {
      ElMessageBox.confirm("¿Estás seguro que deseas eliminar el registro?")
        .then(() => {
          deleteExperience(item);
        })
        .catch(() => {
          // catch error
        });
    };

</script>
